// e420-card-media-swipe.js
(function () {
  var SWIPE_THRESHOLD = 30; // px for horizontal swipe
  var TAP_TOLERANCE = 10; // px of movement allowed to still count as a "tap"

  // Navigate to the product page using the existing card link
  function navigateToCardLink(media) {
    if (!media) return;

    var wrapper = media.closest(".card-wrapper") || media.closest(".card");
    if (!wrapper) return;

    var link =
      wrapper.querySelector(".card__heading a.e420-cardlink") ||
      wrapper.querySelector(".card__heading a");

    if (!link) return;

    var href = link.getAttribute("href");
    if (!href) return;

    window.location.href = href;
  }

  function forceTapNavigation(wrapper) {
    if (!wrapper) return;

    var link =
      wrapper.querySelector(".card__heading a.e420-cardlink") ||
      wrapper.querySelector(".card__heading a");

    if (!link || link.dataset.e420NuclearNav === "1") return;
    link.dataset.e420NuclearNav = "1";

    // Track movement so we can distinguish TAP vs DRAG/SCROLL
    var startX = 0;
    var startY = 0;
    var isTouching = false;

    if (window.PointerEvent) {
      link.addEventListener(
        "pointerdown",
        function (ev) {
          // Only care about touch pointers (mouse should behave normally)
          if (ev.pointerType && ev.pointerType !== "touch") return;
          if (ev.button !== 0) return;

          isTouching = true;
          startX = ev.clientX;
          startY = ev.clientY;
        },
        { capture: true }
      );

      link.addEventListener(
        "pointerup",
        function (ev) {
          if (ev.pointerType && ev.pointerType !== "touch") return;
          if (ev.button !== 0) return;
          if (!isTouching) return;

          isTouching = false;

          var dx = Math.abs(ev.clientX - startX);
          var dy = Math.abs(ev.clientY - startY);

          // If the finger moved too much, treat as scroll/drag → don't navigate
          if (dx > TAP_TOLERANCE || dy > TAP_TOLERANCE) {
            return;
          }

          var href = link.getAttribute("href");
          if (!href) return;

          // Real tap: take over navigation
          ev.preventDefault();
          ev.stopPropagation();
          window.location.href = href;
        },
        { capture: true }
      );

      link.addEventListener(
        "pointercancel",
        function () {
          isTouching = false;
        },
        { capture: true }
      );
    } else {
      // Older Safari / non-PointerEvent browsers
      var touchStartX = 0;
      var touchStartY = 0;
      var touchActive = false;

      link.addEventListener(
        "touchstart",
        function (ev) {
          var t = ev.changedTouches && ev.changedTouches[0];
          if (!t) return;

          touchActive = true;
          touchStartX = t.clientX;
          touchStartY = t.clientY;
        },
        { capture: true }
      );

      link.addEventListener(
        "touchend",
        function (ev) {
          if (!touchActive) return;
          touchActive = false;

          var t = ev.changedTouches && ev.changedTouches[0];
          if (!t) return;

          var dx = Math.abs(t.clientX - touchStartX);
          var dy = Math.abs(t.clientY - touchStartY);

          if (dx > TAP_TOLERANCE || dy > TAP_TOLERANCE) {
            // Drag/scroll, not a tap
            return;
          }

          var href = link.getAttribute("href");
          if (!href) return;

          ev.preventDefault();
          ev.stopPropagation();
          window.location.href = href;
        },
        { capture: true }
      );

      link.addEventListener(
        "touchcancel",
        function () {
          touchActive = false;
        },
        { capture: true }
      );
    }
  }

  function initMediaSwipe(media) {
    // Avoid double-binding
    if (media.dataset.e420SwipeInitialized === "1") return;

    // Respect theme toggle: if data-e420-mobile-swipe="false", do nothing
    var mobileToggle = media.dataset.e420MobileSwipe;
    if (mobileToggle === "false") return;

    // Slides = any pane we explicitly mark
    var panes = media.querySelectorAll(".e420-card-pane");
    if (!panes.length) return; // still allow single-slide for tap-to-open

    media.dataset.e420SwipeInitialized = "1";

    var totalSlides = panes.length;
    media.dataset.e420SlideMax = String(totalSlides);

    // Normalise current slide
    var current = parseInt(media.dataset.e420Slide || "1", 10);
    if (!current || current < 1) current = 1;
    if (current > totalSlides) current = totalSlides;
    media.dataset.e420Slide = String(current);
    media.style.setProperty("--e420-slide", String(current));

    // Ensure each pane has a slide index (Liquid already sets these,
    // but this is a safe fallback)
    panes.forEach(function (pane, idx) {
      if (!pane.style.getPropertyValue("--e420-slide-index")) {
        pane.style.setProperty("--e420-slide-index", String(idx + 1));
      }
    });

    var startX = 0;
    var startY = 0;
    var isTracking = false;
    var activePointerId = null;

    function goToSlide(next) {
      if (next < 1) next = 1;
      if (next > totalSlides) next = totalSlides;
      if (next === current) return;

      current = next;
      media.dataset.e420Slide = String(current);
      media.style.setProperty("--e420-slide", String(current));
    }

    // ---------- Pointer-based swipe (modern browsers) ----------
    function onPointerDown(ev) {
      // Only handle touch pointers – let mouse/trackpad drag the outer slider if needed
      if (ev.pointerType && ev.pointerType !== "touch") return;

      activePointerId = ev.pointerId;
      startX = ev.clientX;
      startY = ev.clientY;
      isTracking = true;

      // Prefer inner swipe, but outer components will still see pointerup
      ev.stopPropagation();
    }

    function onPointerMove(ev) {
      if (!isTracking || ev.pointerId !== activePointerId) return;
      if (ev.pointerType && ev.pointerType !== "touch") return;

      // Don't let the outer carousel treat this as a drag
      ev.stopPropagation();
    }

    function onPointerUp(ev) {
      if (!isTracking || ev.pointerId !== activePointerId) return;
      if (ev.pointerType && ev.pointerType !== "touch") return;

      isTracking = false;

      var dx = ev.clientX - startX;
      var dy = ev.clientY - startY;
      var dxAbs = Math.abs(dx);
      var dyAbs = Math.abs(dy);

      var isHorizontalSwipe = dxAbs >= SWIPE_THRESHOLD && dxAbs >= dyAbs;
      var isTap = dxAbs <= TAP_TOLERANCE && dyAbs <= TAP_TOLERANCE;

      if (isHorizontalSwipe) {
        // Horizontal swipe: change slide ONLY, but DO NOT stopPropagation
        if (dx < 0) {
          goToSlide(current + 1);
        } else {
          goToSlide(current - 1);
        }
        // No ev.stopPropagation() here → outer code sees pointerup and can reset
        return;
      }

      if (isTap) {
        // Treat as a tap on the media → navigate using the card link
        ev.stopPropagation();
        ev.preventDefault();
        navigateToCardLink(media);
      }
    }

    function onPointerCancel(ev) {
      if (!isTracking || ev.pointerId !== activePointerId) return;
      isTracking = false;
      ev.stopPropagation();
    }

    // ---------- Touch fallback (older Safari etc.) ----------
    function getTouchPoint(ev) {
      if (ev.changedTouches && ev.changedTouches.length) {
        return ev.changedTouches[0];
      }
      if (ev.touches && ev.touches.length) {
        return ev.touches[0];
      }
      return null;
    }

    function onTouchStart(ev) {
      if (window.PointerEvent) return; // pointer events version already handles it
      var p = getTouchPoint(ev);
      if (!p) return;

      startX = p.clientX;
      startY = p.clientY;
      isTracking = true;

      ev.stopPropagation();
    }

    function onTouchMove(ev) {
      if (window.PointerEvent) return;
      if (!isTracking) return;

      ev.stopPropagation();
    }

    function onTouchEnd(ev) {
      if (window.PointerEvent) return;
      if (!isTracking) return;

      isTracking = false;

      var p = getTouchPoint(ev);
      if (!p) return;

      var dx = p.clientX - startX;
      var dy = p.clientY - startY;
      var dxAbs = Math.abs(dx);
      var dyAbs = Math.abs(dy);

      var isHorizontalSwipe = dxAbs >= SWIPE_THRESHOLD && dxAbs >= dyAbs;
      var isTap = dxAbs <= TAP_TOLERANCE && dyAbs <= TAP_TOLERANCE;

      if (isHorizontalSwipe) {
        // Horizontal swipe: change slide, but again DO NOT stopPropagation
        if (dx < 0) {
          goToSlide(current + 1);
        } else {
          goToSlide(current - 1);
        }
        // No ev.stopPropagation() here either
        return;
      }

      if (isTap) {
        ev.stopPropagation();
        ev.preventDefault();
        navigateToCardLink(media);
      }
    }

    function onTouchCancel(ev) {
      if (window.PointerEvent) return;
      if (!isTracking) return;
      isTracking = false;
      ev.stopPropagation();
    }

    // Attach gesture listeners directly on the MEDIA element
    if (window.PointerEvent) {
      media.addEventListener("pointerdown", onPointerDown, { capture: true });
      media.addEventListener("pointermove", onPointerMove, { capture: true });
      media.addEventListener("pointerup", onPointerUp, { capture: true });
      media.addEventListener("pointercancel", onPointerCancel, {
        capture: true,
      });
    } else {
      media.addEventListener("touchstart", onTouchStart, {
        capture: true,
        passive: true,
      });
      media.addEventListener("touchmove", onTouchMove, { capture: true });
      media.addEventListener("touchend", onTouchEnd, { capture: true });
      media.addEventListener("touchcancel", onTouchCancel, { capture: true });
    }

    // 💣 NUCLEAR TAP HOOK: force title-link taps to navigate immediately
    var wrapper = media.closest(".card-wrapper") || media.closest(".card");
    forceTapNavigation(wrapper);
  }

  function initAll(root) {
    root = root || document;
    root
      .querySelectorAll(".card__media .media.media--hover-effect")
      .forEach(initMediaSwipe);
  }

  // 🔍 expose helper for manual re-init if needed
  window.e420InitCardMediaSwipe = initAll;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  // Re-init for dynamically loaded sections (Shopify sections)
  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target || document);
  });

  // 👇 Still watch for late-added product cards
  if ("MutationObserver" in window) {
    var e420SwipeObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!(node instanceof Element)) return;

          if (
            node.matches &&
            node.matches(".card__media .media.media--hover-effect")
          ) {
            initMediaSwipe(node);
            return;
          }

          if (node.querySelectorAll) {
            var medias = node.querySelectorAll(
              ".card__media .media.media--hover-effect"
            );
            if (medias.length) {
              medias.forEach(initMediaSwipe);
            }
          }
        });
      });
    });

    e420SwipeObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }
})();
